import { render } from "./InternalGoogleAdsDashboard.vue?vue&type=template&id=480b5693"
import script from "./InternalGoogleAdsDashboard.vue?vue&type=script&lang=js"
export * from "./InternalGoogleAdsDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__